import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class OpenDesignCardStyle {
    /**
     * Returns styles.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing } = options.theme;
        return css `
			${Text.CSS}

			h2 {
				margin-top: 0;
				margin-bottom: ${spacing.space150 / 16}rem;
			}

			.helpMessageWithTabs {
				margin-bottom: ${spacing.space50 / 16}rem;
			}

			.helpMessageWithoutTabs {
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			.unavailableDesignError {
				margin-top: ${spacing.space75 / 16}rem;
			}

			.centered {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}

			.text-center {
				text-align: center;
			}

			.design-items {
				display: flex;
				flex-direction: column;
				gap: ${spacing.space200 / 16}rem;
			}
			.header {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
			}
		`;
    }
}
//# sourceMappingURL=OpenDesignCardStyle.js.map